<template>
  <div class="qa">
    <div>
      <span class="qa__title">Keyword Quick Add</span>
    </div>
    <div class="qa__body">
      <div
        class="tab-pane fade show active"
        id="nav-keywords"
        role="tabpanel"
        aria-labelledby="nav-keywords-tab"
      >
        <br />
        <form>
          <div class="form-group">
            <div>
              <div class="ctrl ctrl__left">
                <div
                  id="div_add_all"
                  v-if="Object.keys(msvLabels).length > 1"
                  style="display: inline"
                >
                  <label class="qa__checkbox">
                    <input
                      type="checkbox"
                      id="all_msv_checkbox"
                      v-model="allMsvSelected"
                    />
                    Add all MSVs
                  </label>
                </div>
              </div>
              <div class="ctrl ctrl__right">
                <div style="display: inline">
                  <label class="qa__limit-text" :class="keywordCount > recordLimit && 'qa__error_text'">
                    {{ keywordCount.toLocaleString() }} / {{ recordLimit.toLocaleString() }} Keywords Populated
                  </label>
                </div>
              </div>
              <br />
              <div class="global-selectors">
                <label class="qa__input">
                  <span class="qa__label">Rel Score</span>
                  <base-select
                    :headerStyle="{ 'border-width': '2px' }"
                    :smartInputStyle="{ 'padding-left': '20px' }"
                    :placeholderStyle="{ 'padding-left': '20px' }"
                    :isHideArrow="true"
                    ref="global-score"
                    class="qa__field"
                    placeholder="Rel Score"
                    :options="relScoreOptions"
                    :selectStyle="{ height: '40px !important' }"
                    v-model="globalRelScore"
                    :max-height-list="450"
                  >
                    <base-material-design-icon class="qa__clear_globals qa__clear_globals__score" v-if="globalRelScore" @click.stop="clearGlobalScore" icon="close" />
                  </base-select>
                  <!-- <span class="form__error-message" v-if="$parent.errorFields.url">{{ $parent.errorFields.url }}</span> -->
                </label>
                <label class="qa__input qa__input__url">
                  <span class="qa__label">Mapped URL</span>
                  <base-smart-input-autocomplete
                    easyModel
                    ref="global-url"
                    class="qa__field"
                    :options="autocompleteMappedUrls"
                    v-model="globalUrl"
                    placeholder="Mapped URL"
                   >
                    <base-material-design-icon class="qa__clear_globals" v-if="globalUrl" @click.stop="clearGlobalUrl" icon="close" />
                  </base-smart-input-autocomplete>
                  <!-- <span class="form__error-message" v-if="$parent.errorFields.url">{{ $parent.errorFields.url }}</span> -->
                </label>
                <input
                  @click.prevent="applyGlobalValues()"
                  id="new_keywords_modal_button_add_keywords"
                  type="button"
                  name="action"
                  value="Apply"
                  class="btn btn-primary submit-button qa__button qa__button_submit qa__input qa__input__apply"
                />
              </div>
              <br />
              <div style="position: relative;">
                <div
                  style="margin: 0"
                  class="row"
                  id="quick_add_keyword_table"
                ></div>
                <div
                  v-if="isLoading"
                  class="qa__update-loader"
                >
                  <div class="qa__update-loader-content">
                    <div class="qa__update-loader-text">This may take up to one minute</div>
                    <base-loader class="qa__update-loader-ring" />
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="qa__button qa__button_add_row"
                @click="addRow"
              >
                <base-material-design-icon icon="plus" class="qa__icon" />
                <span>Add Row</span>
              </button>
            </div>
            <div class="qa__error_message">
              <span v-show="invalidText" class="invalid-count">
                {{ invalidText }}
              </span>
            </div>
            <div class="qa__controls">
              <button
                type="button"
                class="qa__button qa__button_clear_table"
                @click="clearTable"
              >
                <base-material-design-icon icon="restore" class="qa__icon" />
                <span>Reset Data</span>
              </button>
              <button
                v-show="!readClipboardRestricted"
                type="button"
                class="qa__button qa__button_import_clipboard"
                @click="importClipboard"
              >
                <base-material-design-icon icon="paste" class="qa__icon" />
                <span>Import from Clipboard</span>
              </button>
              <label class="qa__button qa__button_file_upload">
                <input
                  type="file"
                  accept=".csv, .tsv"
                  ref="fileUploadKeywords"
                  @change="handleFileChange($event)"
                />
                <base-material-design-icon icon="upload" class="qa__icon" />
                <span>Upload File</span>
              </label>
              <button
                type="button"
                class="qa__button qa__button_download_template"
                @click="downloadTemplate()"
              >
                <base-material-design-icon
                  icon="fileDocument"
                  class="qa__icon"
                />
                <span>download template</span>
              </button>
              <button
                type="button"
                class="qa__button qa__button_cancel"
                @click="close()"
              >
                Cancel
              </button>
              <input type="hidden" name="action" value="Add Keywords" />
              <input
                @click.prevent="apply()"
                id="new_keywords_modal_button_add_keywords"
                type="button"
                name="action"
                value="Add Keywords"
                class="btn btn-primary submit-button qa__button qa__button_submit"
                :class="{ 'submit-disabled': !submitAllowed }"
                :disabled="!submitAllowed"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal backdrop loader -->
    <div
      v-if="isLoading"
      class="qa__modal-backdrop"
    >
      <div class="qa__modal-backdrop-content">
        <div class="qa__modal-backdrop-text">This may take up to one minute</div>
        <base-loader class="qa__modal-backdrop-ring" />
      </div>
    </div>
    <base-material-design-icon
      style="font-size:14px;"
      ref="icon"
      icon="closeCircle"
    />
  </div>
</template>

<script>
import papaparse from 'papaparse'
import BaseModalMixins from '@/common/BaseModalMixins'
import Tabulator from 'tabulator-tables'
import ToasterService from '@/services/toasterService'
import { cloneDeep } from 'lodash'

export default {
  name: 'CreateKeywords',
  mixins: [BaseModalMixins],
  props: {
    msvLabelList: Array,
    webPropertyPatterns: Array,
    showDifficultyScore: Boolean,
    mappedUrls: Array
  },
  data () {
    return {
      recordLimit: 4000,
      globalUrl: '',
      globalRelScore: 1,
      keywords: '',
      all_msvs: false,
      rawIconHtmlString: '',
      urlValidationRegex: /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i,
      readClipboardRestricted:
        navigator.userAgent.indexOf('Firefox') > -1 ||
        navigator.userAgent.indexOf('Trident') > -1 ||
        navigator.userAgent.indexOf('MSIE') > -1,
      allMsvSelected: false,
      placeholderSecondLine: `(${
        navigator.platform.indexOf('Mac') > -1 ? 'Cmd' : 'Ctrl'
      } + v)`,
      submitAllowed: false,
      invalidText: null,
      mounted: false,
      relScoreOptions: [1, 2, 3, 4, 5].map(num => ({ label: num, value: num })),
      keywordCount: 0,
      isLoading: false
    }
  },
  methods: {
    applyGlobalValues () {
      this.setColumnValue('score', this.globalRelScore)
      this.setColumnValue('url', this.globalUrl)
    },
    clearGlobalScore () {
      this.globalRelScore = ''
      this.setColumnValue('score', null)
    },
    clearGlobalUrl () {
      this.globalUrl = ''
      const input = this.$refs['global-url']
      if (input) {
        input.clear()
      }
      this.applyGlobalValues()
    },
    setColumnValue (column, value) {
      const updatedRows = this.table.getData().map(row => {
        return { ...row, [column]: value }
      })
      this.table.replaceData(updatedRows)
      this.updateForm(updatedRows)
    },
    setGlobalUrl (val) {
      this.setColumnValue('url', val.toString())
    },
    handleFileChange (e) {
      this.isLoading = true
      const file = e.target.files[0]
      let reader = new FileReader()
      reader.readAsText(file)
      reader.onload = () => {
        this.handleDataToTable(reader.result)
        this.$refs.fileUploadKeywords.value = null
        this.isLoading = false
      }
      reader.onerror = function () {
        console.log(reader.error)
        this.isLoading = false
      }
    },
    downloadTemplate () {
      this.table.download('csv', 'add-keyword-template.csv')
    },
    isMsvValid (cell, value) {
      if (value && value.replaceAll(',', '').length > 15) {
        return false
      }
      if (cell.getColumn().getField() === 'msv1') {
        return value && value.match(/^(\d+|\d{1,3}(,\d{3})*)$/)
      }
      return !value || value.match(/^(\d+|\d{1,3}(,\d{3})*)$/)
    },
    isTableValid (table) {
      const validated = table.validate()
      return validated && !validated.length
    },
    toggleSubmitAllowed (table) {
      const rowCount = table.getDataCount()
      this.keywordCount = rowCount
      const overRowLimit = rowCount > this.recordLimit
      if (this.isTableValid(table) && rowCount && !overRowLimit) {
        this.invalidText = null
        this.submitAllowed = true
      } else if (overRowLimit) {
        this.invalidText = `Too many records! (${rowCount} / ${this.recordLimit})`
        this.submitAllowed = false
      } else {
        const invalidCount = table.getInvalidCells().length
        if (invalidCount) {
          this.invalidText =
            invalidCount > 1
              ? `There are ${invalidCount} invalid cells!`
              : `There is 1 invalid cell!`
        } else {
          this.invalidText = null
        }
        this.submitAllowed = false
      }
    },
    addRow () {
      const newRowMsvCols = Object.keys(this.msvLabels).reduce((acc, cur) => {
        acc[cur] = ''
        return acc
      }, {})
      const row = { keyword: '', ...newRowMsvCols, score: '1', url: '' }
      if (this.showDifficultyScore) {
        row.difficultyScore = ''
      }
      this.table.addRow(row)
      this.toggleSubmitAllowed(this.table)
    },
    clearTable () {
      this.table.clearData()
      this.toggleSubmitAllowed(this.table)
      this.clearGlobalScore()
      this.clearGlobalUrl()
    },
    importClipboardFromPlaceholder (event) {
      const isPlaceholder = Array.from(event.currentTarget.children).filter(
        (el) => {
          return el.classList.contains('tabulator-placeholder')
        }
      ).length
      const isDeleteBtn = event.target.matches('path, svg, .tabulator-cell')
      if (isPlaceholder && !isDeleteBtn) {
        this.table.clearData()
        this.importClipboard()
      }
    },
    handleDataToTable (data) {
      const parsedData = this.parsePaste(data)
      if (!parsedData) {
        this.handlePasteError(data)
      } else {
        this.table.clearData()
        parsedData.forEach((row) => this.table.addRow(row))
        this.handlePasted()
      }
    },
    importClipboard () {
      this.isLoading = true
      try {
        navigator.clipboard
          .readText()
          .then((clipboard) => {
            this.handleDataToTable(clipboard)
            this.isLoading = false
          })
          .catch((err) => {
            console.error('Failed to read clipboard contents: ', err)
            this.isLoading = false
          })
      } catch (e) {
        console.error(e)
        this.isLoading = false
      }
    },
    deleteRow (e, cell) {
      if (this.table.getDataCount() < 2) {
        this.table.clearData()
      } else {
        cell.getRow().delete()
      }
      this.toggleSubmitAllowed(this.table)
    },
    mapLineToRowObject (row, columnIndices) {
      if (!columnIndices) {
        if (this.allMsvSelected) {
          columnIndices = {
            keyword: 0
          }
          this.msvColumnDefinitions.forEach((col, i) => {
            columnIndices[col.field] = i + 1
          })
          const msvCount = this.msvColumnDefinitions.length
          if (this.showDifficultyScore) {
            columnIndices['url'] = msvCount + 1
            columnIndices['score'] = msvCount + 2
            columnIndices['difficultyScore'] = msvCount + 3
          } else {
            columnIndices['url'] = msvCount + 1
            columnIndices['score'] = msvCount + 2
          }
        } else {
          columnIndices = {
            keyword: 0,
            msv1: 1
          }
          if (this.showDifficultyScore) {
            columnIndices['url'] = 2
            columnIndices['score'] = 3
            columnIndices['difficultyScore'] = 4
          } else {
            columnIndices['url'] = 2
            columnIndices['score'] = 3
          }
        }
      }
      let result = {
        keyword: row[columnIndices['keyword']] || '',
        msv1: row[columnIndices['msv1']] || '',
        score: row[columnIndices['score']] || '1',
        url: row[columnIndices['url']] || ''
      }
      if (this.showDifficultyScore) {
        result['difficultyScore'] = row[columnIndices['difficultyScore']] || ''
      }
      if (this.allMsvSelected) {
        result = {
          ...result,
          ...(columnIndices['msv2'] && {
            msv2: row[columnIndices['msv2']] || ''
          }),
          ...(columnIndices['msv3'] && {
            msv3: row[columnIndices['msv3']] || ''
          }),
          ...(columnIndices['msv4'] && {
            msv4: row[columnIndices['msv4']] || ''
          })
        }
      }
      return result
    },
    validateHeader (row) {
      return (
        row.includes('keyword') ||
        row.includes('msv') ||
        row.includes('metric_msv_broad_adjusted_1') ||
        row.includes('metric_msv_broad_adjusted_2') ||
        row.includes('metric_msv_broad_adjusted_3') ||
        row.includes('metric_msv_broad_adjusted_4') ||
        row.some((header) =>
          this.msvColumnDefinitions.map((col) => col.title).includes(header)
        ) ||
        row.includes('difficulty score') ||
        row.includes('score') ||
        row.includes('url')
      )
    },
    parsePaste (clipboard) {
      let clipboardArray = []
      try {
        clipboard = papaparse.parse(clipboard).data
        let columnIndices = null
        let firstRow = clipboard[0].map((col) => col.toLowerCase().trim())
        if (this.validateHeader(firstRow)) {
          columnIndices = firstRow.reduce((acc, cur, idx) => {
            if (cur === 'keyword' || cur === 'score' || cur === 'url') {
              acc[cur] = idx
            } else if (cur === 'difficulty score' || cur === 'keyword difficulty score') {
              acc['difficultyScore'] = idx
            } else if (cur === 'msv' || cur === 'metric_msv_broad_adjusted_1') {
              acc['msv1'] = idx
            } else if (cur === 'metric_msv_broad_adjusted_2') {
              acc['msv2'] = idx
            } else if (cur === 'metric_msv_broad_adjusted_3') {
              acc['msv3'] = idx
            } else if (cur === 'metric_msv_broad_adjusted_4') {
              acc['msv4'] = idx
            } else {
              this.msvColumnDefinitions.forEach((col) => {
                const title = col.title.toLowerCase().trim()
                if (`${cur} msv` === title || cur === title) {
                  acc[col.field] = idx
                }
              })
            }
            return acc
          }, {})
          clipboard = clipboard.slice(1)
        } else if (firstRow[0] === 'keywords-everywhere-my-keywords') {
          // handle paste from KeywordsEverywhere Favorites table
          clipboard = clipboard.slice(3)
          clipboard = clipboard.map(row => {
            return [ row[0], row[1] ]
          })
        }
        clipboardArray = clipboard.map((row) =>
          this.mapLineToRowObject(row, columnIndices)
        )
        clipboardArray = clipboardArray.filter(
          (row) =>
            row.keyword ||
            row.msv1 ||
            row.msv2 ||
            row.msv3 ||
            row.msv4 ||
            row.difficultyScore ||
            row.score ||
            row.url
        )

        // handles dataChanged if Ctrl+v paste
        this.updateForm(clipboardArray)
      } catch {
        return false
      }
      return clipboardArray
    },
    handlePasted (clipboard, rowData, rows) {
      this.toggleSubmitAllowed(this.table)
    },
    handlePasteError (clipboard) {
      let errorText =
        'There was an issue pasting your selection...\n\nDid you select the appropriate columns?'
      ToasterService.showToast(ToasterService.INFO_TYPE, errorText)
    },
    isValidWebProp (url) {
      return this.webPropertyPatterns.some((pattern) =>
        url.toLowerCase().startsWith(pattern.slice(0, -1).toLowerCase())
      )
    },
    isUrlValid (cell, value) {
      return (
        !value ||
        (value.trim().match(this.urlValidationRegex) &&
          this.isValidWebProp(value.trim()))
      )
    },
    formatRowData (rowData) {
      if (this.allMsvSelected) {
        let result = `${rowData['keyword']}\t`
        this.msvColumnDefinitions.forEach((col) => {
          result += `${rowData[col.field] || 0}\t`
        })
        if (this.showDifficultyScore) {
          result += `${rowData['difficultyScore']}\t${rowData['score']}\t${rowData['url']}\n`
        } else {
          result += `${rowData['score']}\t${rowData['url']}\n`
        }
        return result
      } else {
        if (this.showDifficultyScore) {
          return `${rowData['keyword']}\t${rowData['msv1']}\t${rowData['difficultyScore']}\t${rowData['score']}\t${rowData['url']}\n`
        } else {
          return `${rowData['keyword']}\t${rowData['msv1']}\t${rowData['score']}\t${rowData['url']}\n`
        }
      }
    },
    updateForm (data) {
      const tsvData = data.reduce((acc, cur) => {
        return acc + this.formatRowData(cur)
      }, '')
      this.keywords = tsvData
      this.toggleSubmitAllowed(this.table)
    },
    handleTableBuilt () {
      const tableHolder = document.getElementsByClassName(
        'tabulator-tableHolder'
      )
      Array.from(tableHolder).forEach((element) => {
        element.addEventListener('click', this.importClipboardFromPlaceholder)
      })
    },
    close () {
      this.$emit('close')
    },
    apply () {
      this.isLoading = true
      const form = {
        keywords: this.keywords,
        all_msvs: this.all_msvs,
        include_difficulty_score: this.showDifficultyScore
      }
      this.$emit('applyKeywords', form)
    },
    stopLoading () {
      this.isLoading = false
    }
  },
  computed: {
    autocompleteMappedUrls () {
      return this.mappedUrls.filter(v => v.label.includes(this.globalUrl))
    },
    msvLabels () {
      const msv1Label = this.msvLabelList[0] && this.msvLabelList[0].title
      const msv2Label = this.msvLabelList[1] && this.msvLabelList[1].title
      const msv3Label = this.msvLabelList[2] && this.msvLabelList[2].title
      const msv4Label = this.msvLabelList[3] && this.msvLabelList[3].title

      const labels = {
        ...(msv1Label && { msv1: `${msv1Label.toUpperCase()} MSV` }),
        ...(msv2Label && { msv2: `${msv2Label.toUpperCase()} MSV` }),
        ...(msv3Label && { msv3: `${msv3Label.toUpperCase()} MSV` }),
        ...(msv4Label && { msv4: `${msv4Label.toUpperCase()} MSV` })
      }
      if (Object.keys(labels).length < 2) {
        labels['msv1'] = labels['msv1'] || 'MSV 1'
      }
      return labels
    },
    msvColumnDefinitions () {
      return Object.keys(this.msvLabels).map((key) => {
        return {
          title: this.msvLabels[key],
          field: key,
          widthShrink: 0,
          editor: 'input',
          validator: [{ type: this.isMsvValid }]
        }
      })
    },
    difficultyScoreColumnDefinition () {
      const columnList = []
      if (this.showDifficultyScore) {
        columnList.push({
          title: 'Difficulty Score',
          field: 'difficultyScore',
          widthShrink: 0,
          editor: 'input',
          validator: [{ type: this.isMsvValid }]
        })
      }
      return columnList
    },
    tableConfig () {
      return {
        maxHeight: 400,
        data: [],
        columns: this.keywordTableColumns,
        layout: 'fitColumns',
        tooltipsHeader: true,
        tooltips: (cell) => {
          let tooltipText = ''
          const cellValue = cell.getValue() || ''
          if (cell.validate()) {
            tooltipText = cellValue
          } else {
            switch (cell.getField()) {
              case 'keyword':
                if (!cellValue.length) {
                  tooltipText = 'Missing Keyword!'
                } else if (cellValue.length > 255) {
                  tooltipText = 'Keyword should be less than 256 characters!'
                } else {
                  tooltipText = 'Invalid Keyword!'
                }
                break
              case 'difficultyScore':
                tooltipText = 'Invalid Difficulty Score! (Should be a non-negative integer)'
                break
              case 'score':
                tooltipText =
                  'Invalid Score! (Should be an integer between -1 and 5)'
                break
              case 'url':
                if (!cellValue.trim().match(this.urlValidationRegex)) {
                  tooltipText = 'Invalid URL format!'
                } else if (!this.isValidWebProp(cellValue.trim())) {
                  tooltipText = 'Invalid Web Property!'
                } else {
                  tooltipText = 'Invalid URL!'
                }
                break
              case 'msv1':
                if (!cellValue.trim().length) {
                  tooltipText = 'Missing MSV!'
                } else {
                  tooltipText =
                    'Invalid MSV! (Should be a non-negative integer)'
                }
                break
              case 'msv2':
              case 'msv3':
              case 'msv4':
                tooltipText = 'Invalid MSV! (Should be a non-negative integer)'
                break
            }
          }
          return tooltipText
        },
        tableBuilt: this.handleTableBuilt,
        clipboard: true,
        clipboardPasteAction: 'replace',
        clipboardPasteParser: this.parsePaste,
        clipboardPasteError: this.handlePasteError,
        clipboardPasted: this.handlePasted,
        dataEdited: this.updateForm,
        validationMode: 'highlight',
        placeholder: `<div><span style="display:block;">Click here to import from clipboard</span><span style="display:block;text-align:center;">${this.placeholderSecondLine}</span></div>`
      }
    },
    keywordTableFullColumns () {
      return [
        {
          formatter: (cell, formatterParams, onRendered) => {
            return this.rawIconHtmlString // this provides material-design-icon as raw html
          },
          field: 'delete',
          headerSort: false,
          width: 40,
          hozAlign: 'center',
          cellClick: this.deleteRow,
          download: false
        },
        {
          title: 'Keyword',
          field: 'keyword',
          widthGrow: 1.5,
          widthShrink: 0,
          editor: 'input',
          validator: ['required', 'maxLength:255'],
          mutator: (value, data, type, params, component) => {
            return value.trim().replace(/\s+/g, ' ')
          }
        },
        ...this.msvColumnDefinitions,
        {
          title: 'URL',
          field: 'url',
          widthGrow: 3,
          widthShrink: 0,
          validator: [{ type: this.isUrlValid }],
          editor: 'autocomplete',
          editorParams: {
            showListOnEmpty: true,
            freetext: true,
            values: this.mappedUrls.map(url => url.label)
          }
        },
        {
          title: 'Rel Score',
          field: 'score',
          widthShrink: 0,
          editor: 'number',
          editorParams: {
            min: -1,
            max: 5
          },
          validator: ['integer', 'min:-1', 'max:5']
        },
        ...this.difficultyScoreColumnDefinition
      ]
    },
    keywordTableColumns () {
      const cols = cloneDeep(this.keywordTableFullColumns)
      cols.splice(3, this.msvColumnDefinitions.length - 1)
      return cols
    }
  },
  watch: {
    mappedUrls: {
      handler () {
        this.table.getColumn('url').getDefinition().editorParams.values = this.mappedUrls.map(url => url.label)
        this.table.redraw()
      },
      deep: true
    },
    allMsvSelected: function (val) {
      if (val) {
        this.table.setColumns(this.keywordTableFullColumns)
      } else {
        this.table.setColumns(this.keywordTableColumns)
      }
      const tableData = this.table.getData().map((row) => {
        delete row.delete
        if (!val) {
          delete row.msv2
          delete row.msv3
          delete row.msv4
        }
        return row
      })
      this.updateForm(tableData)
      this.all_msvs = val
    }
  },
  mounted () {
    this.rawIconHtmlString = this.$refs.icon.$el.outerHTML.toString()
    this.$refs.icon.$el.parentNode.removeChild(this.$refs.icon.$el)

    this.table = new Tabulator(
      '#quick_add_keyword_table',
      this.tableConfig
    )
    this.mounted = true
  }
}
</script>

<style>
.tabulator-validation-fail {
  background-color: #ffdddd;
  border: none !important;
}

.tabulator-placeholder {
  cursor: pointer;
  height: 100%;
  background-color: #f4f6fb;
}
</style>
<style scoped lang="scss">

.global-selectors {
  height: 60px !important;
  display: flex;
  height: 30px;
  margin-bottom: 5px;
  justify-content: space-between;
  width: 75%;
}
input[type="file"] {
  display: none;
}

input[type="checkbox"] {
  cursor: pointer;
}

.submit-disabled {
  cursor: default !important;
  opacity: 0.4;
}

.qa {
  border-radius: 13px;
  &__title {
    display: block;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
  }
}

.ctrl {
  display: inline-flex;
  height: 30px;
  margin-bottom: 5px;

  &__left {
    width: 50%;
    justify-content: flex-start;
  }

  &__right {
    width: 50%;
    justify-content: flex-end;
  }
}

.qa {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 40px;

  &__body {
      padding: 0 40px 40px 40px;
  }

  &__error_text {
    color: $rfx-red;
  }

  &__clear_globals {
    padding-right: 5px;
    &__score {
      padding-right: 10px;
    }
  }

  &__icon {
    margin-right: 2px;
    font-size: 15px;
  }

  &__error_message {
    height: 10px;
    > span {
      float: right;
    }
  }

  &__input {
    width: 20%;
    &_invalid[type="text"] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
    &__url {
      padding-left: 10px;
      width: 80%;
    }
    &__apply {
      margin-left: 10px;
      margin-top: 20px;
      width: 80px;
    }
  }

  &__field {
    height: 40px !important;
  }

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }

  &__controls {
    display: flex;
    margin-top: 30px;
  }

  &__limit-text {
    font-weight: 600;
  }

  &__checkbox {
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  &__button {
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    border: none;
    outline: none;
    cursor: pointer;

    color: $rfx-dark-march;
    background-color: #fff;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;
    }

    &_add_row {
      width: 100%;
    }

    &_clear_table {
      margin-right: 10px;
    }

    &_import_clipboard {
      margin-right: 10px;
    }

    &_cancel {
      margin-left: auto;
      margin-right: 10px;
    }

    &_file_upload {
      display: flex;
      margin-right: 10px;
      > span {
        margin: 18px 0;
      }
    }

    &_download_template {
      margin-right: 0 10px;
    }
  }

  &__buttons_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__update-loader {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8);
    top: 0;
    left: 0;
    z-index: 1000;
    border-radius: 4px;
    pointer-events: none;
  }

  &__update-loader-ring {
    margin: 0;
  }

  &__update-loader-content {
    text-align: center;
  }

  &__update-loader-text {
    font-size: 18px;
    font-weight: 600;
    display: block;
    margin-bottom: 10px;
  }

  &__modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }

  &__modal-backdrop-content {
    background-color: white;
    padding: 40px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

  &__modal-backdrop-text {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #011627;
  }

  &__modal-backdrop-ring {
    margin: 0;
  }
}
</style>
